export class CategoryNewFilter {
    categoryName
    filterType = 'category'
    constructor(categoryName) {
        this.categoryName = categoryName
    }

    apply(products) {
        return products.filter(product => {
            return (product.Estado.toLowerCase() === 'nuevo' || product.Estado.toLowerCase() === 'proximamente')
        })
    }
}